import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Checkbox, Form, Radio } from 'antd';
import AirModal from '../../../../../common/components/AirModal';
import './AdditionServiceConditions.css';
import K from "../../../../../constants";

@inject('translationsStore', 'moveinStore')
@observer
export default class AdditionServiceConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptedAll: undefined,
      generalConditionsVisible: false,
      privacyVisible: false
    };
  }

  toggleAcceptAll = () => {
    this.setState(prevState => {
      const isAccepted = !prevState.acceptedAll ? true : undefined;

      this.props.form.setFieldsValue({ air_club_profiling: isAccepted, air_club_marketing: isAccepted, air_club_third_parties: isAccepted });
      return {
        acceptedAll: !!isAccepted
      };
    });
  };

  unFlagAcceptAllIfChangedAfterAcceptedAll = () => {
    this.setState(prevState => {
      if (prevState.acceptedAll) {
        return {
          acceptedAll: false
        };
      }
    });
  };

  onSubmit = () => {
    const { moveinStore, form } = this.props;
    const { getFieldsValue } = form;

    const airclub_general = getFieldsValue(['airclub_general'])['airclub_general'];
    const air_club_profiling = getFieldsValue(['air_club_profiling'])['air_club_profiling'];
    const air_club_marketing = getFieldsValue(['air_club_marketing'])['air_club_marketing'];
    const air_club_third_parties = getFieldsValue(['air_club_third_parties'])['air_club_third_parties'];

    moveinStore.setVehicleAdditionalServiceConsent({ reminder_product_consent: true, airclub_general, air_club_profiling, air_club_marketing, air_club_third_parties });

    this.props.onSubmit();
  };

  render() {
    const { translationsStore, form, isSubmitWithAdditionalServiceDisabled } = this.props;
    const { acceptedAll } = this.state;
    return (
      <div className={'OptionalServicesView'}>
        <div className="OptionalServiceDivider" />
        <div className="OptionalServicePrivacy">
          <div className={'GeneralConditionsContainer'}>
            <div className={'GeneralConditionRow'}>
              <Form.Item>
                {form.getFieldDecorator('airclub_general', {
                  valuePropName: 'checked',
                  initialValue: undefined
                })(<Checkbox />)}
              </Form.Item>
              <div className="GeneralConditionText">
                {translationsStore.translate('movein.consents.additional.generalConditions1')}
                <span className="OptionalServiceLink" onClick={() => this.setState({ generalConditionsVisible: true })}>
                  {translationsStore.translate('movein.consents.additional.generalConditionsLink')}
                </span>
                .
              </div>
            </div>
            <div className={'GeneralConditionRow'}>
              <Form.Item>
                {form.getFieldDecorator('carefully_read', {
                  valuePropName: 'checked',
                  initialValue: undefined
                })(<Checkbox />)}
              </Form.Item>
              <div className="GeneralConditionText GeneralConditionSmallPrint">{translationsStore.translate('movein.consents.additional.carefullyRead')}</div>
            </div>
          </div>
          <div className="OptionalServicePrivacyRead">
            {translationsStore.translate('movein.consents.additional.privacyRead1')}
            <span className="OptionalServiceLink" onClick={() => this.setState({ privacyVisible: true })}>
              {translationsStore.translate('movein.consents.additional.privacyReadLink')}
            </span>
          </div>
          <div className="OptionalServiceConsentTitle">{translationsStore.translate('movein.consents.additional.consentTitle')}</div>
          <p className="OptionalServiceText">{translationsStore.translate('movein.consents.additional.consentIntro')}</p>
          <div className="OptionalServiceConsentBlock">
            <p className="OptionalServiceText">{translationsStore.translate('movein.consents.additional.profiling')}</p>
            <div className={'CheckboxContainer'}>
              <Form.Item>
                {form.getFieldDecorator('air_club_profiling', {
                  initialValue: undefined
                })(
                  <Radio.Group onChange={this.unFlagAcceptAllIfChangedAfterAcceptedAll}>
                    <Radio value={true}>{translationsStore.translate('movein.consents.agree')}</Radio>
                    <Radio value={false}>{translationsStore.translate('movein.consents.disagree')}</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="OptionalServiceConsentBlock">
            <p className="OptionalServiceText">{translationsStore.translate('movein.consents.additional.marketing')}</p>
            <div className={'CheckboxContainer'}>
              <Form.Item>
                {form.getFieldDecorator('air_club_marketing', {
                  initialValue: undefined
                })(
                  <Radio.Group onChange={this.unFlagAcceptAllIfChangedAfterAcceptedAll}>
                    <Radio value={true}>{translationsStore.translate('movein.consents.agree')}</Radio>
                    <Radio value={false}>{translationsStore.translate('movein.consents.disagree')}</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="OptionalServiceConsentBlock">
            <p className="OptionalServiceText">{translationsStore.translate('movein.consents.additional.thirdParties')}</p>
            <div className={'CheckboxContainer'}>
              <Form.Item>
                {form.getFieldDecorator('air_club_third_parties', {
                  initialValue: undefined
                })(
                  <Radio.Group onChange={this.unFlagAcceptAllIfChangedAfterAcceptedAll}>
                    <Radio value={true}>{translationsStore.translate('movein.consents.agree')}</Radio>
                    <Radio value={false}>{translationsStore.translate('movein.consents.disagree')}</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </div>
          </div>
          <div className={'LineSeparator'} />
          <div className="OptionalServiceAcceptAll">
            <Checkbox className="OptionalServicePrivacyCheck" onChange={this.toggleAcceptAll} checked={!!acceptedAll} />
            <p>{translationsStore.translate('movein.consents.additional.acceptAll')}</p>
          </div>
        </div>
        <div className="AdditionalServiceButtons">
          <button type="button" className="mv-btn" disabled={isSubmitWithAdditionalServiceDisabled} onClick={this.onSubmit}>
            {translationsStore.translate('movein.stepRegistration.freeService.proceedToSelect')}
          </button>
          <button type="button" className="mv-btn mv-btn--muted" onClick={this.props.onCancelFreeService}>
            {translationsStore.translate('movein.stepRegistration.freeService.proceedWithout')}
          </button>
        </div>

        <AirModal
          className="EmbeddedDocumentModal"
          width="90vw"
          visible={this.state.generalConditionsVisible}
          onCancel={() => {
            this.setState({ generalConditionsVisible: false });
          }}
        >
          <iframe src={K.POLICY_BASE_URL.concat('condizioni-generali-servizi-aggiuntivi-2022-09-23.pdf')} width="100%" height="540" />
        </AirModal>
        <AirModal
          className="EmbeddedDocumentModal"
          width="90vw"
          visible={this.state.privacyVisible}
          onCancel={() => {
            this.setState({ privacyVisible: false });
          }}
        >
          <iframe src={K.POLICY_BASE_URL.concat('privacy-policy-2022-09-23.pdf')} width="100%" height="540" />
        </AirModal>
      </div>
    );
  }
}
